import { makeVar } from '@apollo/client'

export const currentEventIdVar = makeVar('')
